// extracted by mini-css-extract-plugin
module.exports = {"animateFlicker":"FlickerText_animateFlicker__2Nmfu","flickerAnimation":"FlickerText_flickerAnimation__Xu6Ew"};